import { clsx } from 'clsx';

// icons
import ArrowIcon from '@assets/icons/arrow-down.svg?react';

// styles
import css from './styles.module.css';

interface IProps {
  className?: string;
  iconClassname?: string;
  withoutArrow?: boolean;
}

function GoBackButton({
  className,
  iconClassname,
  withoutArrow = false,
}: IProps) {
  const handleGoBack = () => {
    window.history.back(); // Navigates back to the previous page
  };

  const cn = clsx(css.resetButton, css.button, className);
  const iconCn = clsx(css.backIcon, iconClassname);

  return (
    <button className={cn} onClick={handleGoBack}>
      {!withoutArrow && <ArrowIcon className={iconCn} width={24} height={24} />}
      <span> Back</span>
    </button>
  );
}

export default GoBackButton;
